import { combineReducers } from "redux";

import theme from "./theme";
import user from "./user";
import notification from "./notification";

export default combineReducers({ theme, user, notification });
